module.exports = __webpack_public_path__ + "img/About_Freelancers_DARK-02.0466457.svg";